/* eslint-disable jsx-a11y/alt-text */
import { Typography } from "@mui/material";
import Color from "../../theme/color";

const AboutUs = () => {
  return (
    <section id="aboutus">
      <div
        style={{
          marginTop: 50,
          marginBottom: 50,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: "50px 30px 100px 30px",
          flexWrap: "wrap",
          backgroundColor: Color.color26,
          width: "100%",
        }}
      >
        <Typography variant="h3" style={{ marginBottom: 40 }}>
          About Us
        </Typography>
        <Typography style={{ textAlign: "justify" }}>
          At EventPrix, we are passionate about using AI and ML to help you
          discover the best events in your city. Whether you are looking for
          concerts, comedy shows, festivals, or workshops, we have you covered.
          You can easily find and buy tickets for your favorite events on our
          platform, and enjoy hassle-free entry at the venue.
          <br />
          <br /> But that’s not all. We also offer a comprehensive solution for
          event organizers who want to sell tickets, manage their events, and
          grow their audience.
          <br />
          <br />
          With EventPrix, you can access a network of local vendors and social
          influencers who can help you create amazing events and reach more
          people. We are always looking for ways to enhance our platform and
          deliver more value to you. If you have any feedback or issues while
          using our platform, please don’t hesitate to reach out to us at
          contact@eventprix.com. Thank you for trusting EventPrix as your
          ultimate event ticketing partner. We are excited to be part of your
          journey to discover new experiences.
        </Typography>
      </div>
    </section>
  );
};

export default AboutUs;
